import React, { useState, useEffect } from "react";
import { getTopFives } from "../../../../Utilities/calculateNutritionStats";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import "./TopList.css";
let nutrientUnits = require("../../../../Data/nutrientUnits.json");

const TopList = ({ list }) => {
  const [sortValue, setSortValue] = useState("Protein");
  const [fiveToShow, setFiveToShow] = useState([]);
  const [lowest, setLowest] = useState(false);

  useEffect(() => {
    setFiveToShow(getTopFives(list, sortValue, lowest));
  }, [sortValue, lowest]);

  const handleValueChange = (event) => {
    setSortValue(event.target.value);
  };

  const handleOrderChange = (event) => {
    setLowest(event.target.value);
  };

  return (
    <div id="topList">
      <div id="topListToolRow">
        <p className="topListToolText">Show </p>
        <Select value={lowest} onChange={handleOrderChange}>
          <MenuItem value={false}>Top</MenuItem>
          <MenuItem value={true}>Bottom</MenuItem>
        </Select>
        <p className="topListToolText"> five of:</p>
        <Select value={sortValue} onChange={handleValueChange}>
          <MenuItem value={"Protein"}>Protein</MenuItem>
          <MenuItem value={"Kolhydrater"}>Carbohydrates</MenuItem>
          <MenuItem value={"Energi"}>Calories</MenuItem>
          <MenuItem value={"Fett"}>Fat</MenuItem>
          <MenuItem value={"Sockerarter"}>Sugars</MenuItem>
          <MenuItem value={"Fibrer"}>Fibers</MenuItem>
          <MenuItem value={"Salt"}>Salt</MenuItem>
        </Select>
      </div>

      <div className="topListRow">
        <p className="topListTitleText">Name</p>
        <p className="topListTitleText">Amount per 100g</p>
      </div>
      {fiveToShow.map((item) => {
        return (
          <div className="topListRow">
            <p className="topListText">{item.name}</p>
            <p className="topListText">
              {item.amount}
              {nutrientUnits[item.unit_id]}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default TopList;
